import config from './config';
import merge from 'lodash/merge';

let enviroment = process.env.SERVER_ENV || 'development';

if (typeof window !== 'undefined') {
  if (window.location.hostname === 'client1.marxsmith.com') {
    enviroment = 'client1';
  } else if (window.location.hostname === 'client2.marxsmith.com') {
    enviroment = 'client2';
  } else if (window.location.hostname === 'client3.marxsmith.com') {
    enviroment = 'client3';
  } else if (window.location.hostname === 'client4.marxsmith.com') {
    enviroment = 'client4';
  } else if (window.location.hostname === 'client5.marxsmith.com') {
    enviroment = 'client5';
  } else if (window.location.hostname === 'client6.marxsmith.com') {
    enviroment = 'client6';
  } else if (window.location.hostname === 'client7.marxsmith.com') {
    enviroment = 'client7';
  } else if (window.location.hostname === 'client8.marxsmith.com') {
    enviroment = 'client8';
  } else if (window.location.hostname === 'client9.marxsmith.com') {
    enviroment = 'client9';
  } else if (window.location.hostname === 'client10.marxsmith.com') {
    enviroment = 'client10';
  } else if (window.location.hostname === 'client11.marxsmith.com') {
    enviroment = 'client11';
  } else if (window.location.hostname === 'client12.marxsmith.com') {
    enviroment = 'client12';
  } else if (window.location.hostname === 'client13.marxsmith.com') {
    enviroment = 'client13';
  } else if (window.location.hostname === 'client14.marxsmith.com') {
    enviroment = 'client14';
  } else if (window.location.hostname === 'client15.marxsmith.com') {
    enviroment = 'client15';
  } else if (window.location.hostname === 'client16.marxsmith.com') {
    enviroment = 'client16';
  } else if (window.location.hostname === 'client17.marxsmith.com') {
    enviroment = 'client17';
  } else if (window.location.hostname === 'client18.marxsmith.com') {
    enviroment = 'client18';
  } else if (window.location.hostname === 'localhost') {
    enviroment = 'development';
  }
}

let envConfig = require('./config.' + enviroment);
if(envConfig.__esModule){
	envConfig = envConfig.default;
}

const mergedConfig = merge({}, config, envConfig);

export default mergedConfig;



// WEBPACK FOOTER //
// ./config/index.js